type SAMLCustomField = {
  name: string;
  value: string;
};

interface samlDataType {
  url: string;
  SAMLResponse: string;
  customFields: SAMLCustomField[];
}

export const handleRedirect = (samlData: samlDataType) => {
  const form = document.createElement('form');

  form.method = 'POST';
  form.action = samlData.url;
  form.target = '_blank';

  const customData: Record<string, string> = {};

  if (samlData.customFields) {
    samlData.customFields.forEach((field: SAMLCustomField) => {
      customData[field.name] = field.value;
    });
  }

  const formData = {
    SAMLResponse: samlData.SAMLResponse,
    ...customData,
  };

  Object.entries(formData).forEach(([key, value]) => {
    const input = document.createElement('input');

    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
